<template>
  <section>
    <div class="info-title">
      {{ $t('Gattaran_Feedback__EhcV' /** 反馈信息 */) }}
    </div>
    <div v-loading="loading" class="content-wrap">
      <pb-row v-for="(row, idx) in gridFormat" :key="idx" class="grid-row">
        <pb-col v-for="(item, key) in row" :key="key" :span="24">
          <div class="grid-row-title">{{ item.name }}</div>
          <!-- 问题区域 -->
          <span v-if="item.prop === 'area'">{{ getHappenArea }}</span>
          <span v-else-if="item.prop === 'level'">{{ getLevel }}</span>
          <!-- 问题发生链接 -->
          <div v-else-if="item.prop === 'link'">
            <a :href="data[item.prop]" target="_target">{{ data[item.prop] }}</a>
          </div>
          <!-- 问题发生图片 -->
          <div v-else-if="item.prop === 'pic'">
            <pb-image v-for="(img, index) in getImage" :key="index" class="grid-row-image" :src="img.url || ''" :preview-src-list="[img.url || '']" />
          </div>
          <!-- 问题附件 -->
          <div v-else-if="item.prop === 'attachment'" v-show="hasAttachment">
            <!-- 附件名称 -->
            <div class="grid-row-attachment" @click="downloadAttachment">
              <span>
                <img class="grid-row-document-svg" :src="require('../assets/document.svg')" />
                <span class="grid-row-filename">{{ getFileName }}</span>
                <i class="pb-icon-download" />
              </span>
            </div>
          </div>
          <div v-else class="grid-row-content">{{ data[item.prop] }}</div>
        </pb-col>
      </pb-row>
    </div>
  </section>
</template>

<script>
import { ERGENCY_LEVEL } from '../config';
import { gridFormat } from '@/utils/tools';
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      config: [
        {
          prop: 'module',
          name: this.$t('Gattaran_Feedback__QLll' /** 问题发生的Gattaran功能模块 */),
          grid: 1,
        },
        {
          prop: 'area',
          name: this.$t('Gattaran_Feedback__eNEw' /** 问题发生的区域 */),
          grid: 2,
        },
        {
          prop: 'link',
          name: this.$t('Gattaran_Feedback__TtBS' /** 问题发生的页面链接 */),
          grid: 3,
        },
        {
          prop: 'level',
          name: this.$t('Gattaran_Feedback__MQam' /** 紧急程度 */),
          grid: 4,
        },
        {
          prop: 'description',
          name: this.$t('Gattaran_Feedback__dglB' /** 问题描述 */),
          grid: 5,
        },
        {
          prop: 'pic',
          grid: 6,
        },
        {
          prop: 'attachment',
          grid: 7,
        },
      ],
    };
  },
  computed: {
    getHappenArea() {
      try {
        return this.data.area && JSON.parse(this.data.area).join(', ');
      } catch (e) {
        console.error(e);
        return undefined;
      }
    },
    getLevel() {
      const { level } = this.data;
      return ERGENCY_LEVEL[level];
    },
    getImage() {
      try {
        return this.data.pic && JSON.parse(this.data.pic);
      } catch (e) {
        console.error(e);
        return [];
      }
    },
    getFileName() {
      try {
        const attachment = JSON.parse(this.data.attachment);
        if (attachment.length !== 0) {
          return attachment[0].filename;
        } else {
          return '';
        }
      } catch (e) {
        console.error(e);
        return '';
      }
    },
    hasAttachment() {
      try {
        const attachment = this.data.attachment && JSON.parse(this.data.attachment);
        if (attachment && attachment.length !== 0) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    gridFormat() {
      return gridFormat(this.config);
    },
  },
  methods: {
    downloadAttachment() {
      try {
        const attachment = JSON.parse(this.data.attachment);
        if (attachment.length !== 0) {
          window.open(attachment[0].urlHttps);
        } else {
          return '';
        }
      } catch (e) {
        console.error(e);
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-title {
  height: 34px;
  box-sizing: border-box;
  margin: 16px;
  padding: 6px 0 6px 16px;
  background: #f8f8fa;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #282b33;
  line-height: 22px;
  font-weight: 600;
}
.content-wrap {
  margin: 8px 32px 104px;
  word-break: break-word;
  white-space: pre-wrap;
}
.grid-row {
  margin-bottom: 24px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;

  &-title {
    color: #8d9099;
  }

  &-image {
    width: 336px;
    height: 104px;
  }

  &-attachment {
    height: 32px;
    line-height: 32px;
    background: #f8f8fa;
    border-radius: 4px;
    color: #282b33;
    cursor: pointer;
  }

  &-content {
    margin-top: 4px;
    color: #282b33;
  }

  &-document-svg {
    width: 11px;
    margin-left: 11px;
    margin-right: 6px;
  }

  &-filename {
    margin-right: 8px;
  }
}
</style>
